export const NAME = 'vendors';